import { render, staticRenderFns } from "./OwTable.vue?vue&type=template&id=58343dc7&"
import script from "./OwTable.vue?vue&type=script&lang=js&"
export * from "./OwTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports